import React from "react";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import esLocale from "date-fns/locale/es";
import { useStyles } from "./styles";
import { sumarDias } from "./../../utils/sumarDias"
const PickerMod = (props) => {
  const {
    id = "date-picker-inline",
    label = "Date picker",
    formatFecha = "dd/MM/yyyy",
    selectedDate = new Date(),
    views = ["year", "month", "date"],
    setSelectedDate = () => { },
    disablePast = true,
    disableFuture = false,
    disableToolbar = true,
    disabled = false,
    variant = "inline",
    inputVariant = "outlined",
    dias = 0,
  } = props;
  const classes = useStyles();
  const handleDateChange = (date) => {
    setSelectedDate(date);
  }
  if (dias > 0) return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
      <KeyboardDatePicker
        maxDate={sumarDias({ dias })}
        disabled={disabled}
        disablePast={disablePast}
        disableFuture={disableFuture}
        className={classes.margin}
        disableToolbar={disableToolbar}
        variant={variant}
        views={views}
        inputVariant={inputVariant}
        format={formatFecha}
        id={id}
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          "aria-label": label,
        }}
        onKeyDown={(e) => {
          e.preventDefault();
       }}
      />
    </MuiPickersUtilsProvider>
  )
  return (
    <MuiPickersUtilsProvider utils={DateFnsUtils} locale={esLocale}>
      <KeyboardDatePicker
        disabled={disabled}
        disablePast={disablePast}
        disableFuture={disableFuture}
        className={classes.margin}
        disableToolbar={disableToolbar}
        variant={variant}
        views={views}
        inputVariant={inputVariant}
        format={formatFecha}
        id={id}
        label={label}
        value={selectedDate}
        onChange={handleDateChange}
        KeyboardButtonProps={{
          "aria-label": label,
        }}
      />
    </MuiPickersUtilsProvider>
  );
};
export default PickerMod;
